import React, { useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDice, faDiceOne, faDiceTwo, faDiceThree, faDiceFour, faDiceFive, faDiceSix } 
    from '@fortawesome/free-solid-svg-icons';
import { useGame } from '../context/GameContext';

function Rng6Dice(props: any) {
    const [faIcon, setfaIcon] = useState(faDice);
    const { reset } = useGame();
    
    useEffect(() => {
        if(reset) {
            setfaIcon(faDice);
        }
    }, [reset]);

    let generate = async () => {
        for (let i = 0; i < 20; i++) {
            let rng = Math.floor(Math.random() * 6);
            switch (rng) {
                case 0:
                    setfaIcon(faDiceOne);
                    break;
                case 1:
                    setfaIcon(faDiceTwo);
                    break;
                case 2:
                    setfaIcon(faDiceThree);
                    break;
                case 3:
                    setfaIcon(faDiceFour);
                    break;
                case 4:
                    setfaIcon(faDiceFive);
                    break;
                case 5:
                    setfaIcon(faDiceSix);
                    break;
            }
            
            await new Promise(r => setTimeout(r,150));
        }
    }

    return(
        <FontAwesomeIcon 
            icon={ faIcon }
            className="App-icon"
            onClick={ generate }
        />
    );
}
export default Rng6Dice;
